import moment from 'moment';
import {ORDER_FILTER_DATE_KEYS, ORDER_FILTER_LABELS} from './ordersFilterInput';

/**
 * Human-readable labels for the raw OrderFilter form keys.
 *
 * These come from the field registry, so a field added to the panel gets a
 * chip label without a second edit here — the reason `assetKey` once rendered
 * as a raw form key. Only the keys the panel does not own are listed below.
 */
const LABELS = {
  ...ORDER_FILTER_LABELS,
  // Owned by the tab rather than the panel, but still worth naming when a
  // saved view carries one.
  status: 'Status',
  hold: 'On hold',
};

const DATE_KEYS = ORDER_FILTER_DATE_KEYS;

const isEmpty = v =>
  v === undefined ||
  v === null ||
  v === '' ||
  (Array.isArray(v) && v.length === 0);

const formatVal = (key, v) => {
  if (DATE_KEYS.includes(key)) {
    const m = moment(v);
    return m.isValid() ? m.format('DD MMM YYYY') : String(v);
  }
  if (typeof v === 'boolean') return v ? 'Yes' : 'No';
  if (Array.isArray(v)) {
    // The user picker stores `first;last;id;email` composites, and a list of
    // broker ids is no more readable — say how many rather than which.
    if (key === 'recipients' || key === 'brokerIds')
      return `${v.length} selected`;
    return v.join(', ');
  }
  if (typeof v === 'object') return ''; // complex value
  return String(v);
};

/**
 * Turns the ViewOrders filter state into a flat list of display chips.
 * `searchedValue` (ticker/status search) and `user` are tracked separately
 * from the filter form, so they're folded in here too.
 */
export const summarizeOrderFilters = (
  filterValues = {},
  searchedValue = '',
  user,
) => {
  const chips = [];
  if (searchedValue) {
    chips.push({key: '__search', label: 'Search', value: searchedValue});
  }
  if (user) {
    chips.push({
      key: '__user',
      label: 'User',
      value: typeof user === 'string' ? user : 'Selected',
    });
  }
  Object.entries(filterValues || {}).forEach(([k, v]) => {
    if (isEmpty(v)) return;
    chips.push({key: k, label: LABELS[k] || k, value: formatVal(k, v)});
  });
  return chips;
};

export const countOrderFilters = (filterValues, searchedValue, user) =>
  summarizeOrderFilters(filterValues, searchedValue, user).length;
